function initAll() {
  popupInit();
  tabsInit();
  inputsInit();
  activeToggleInit();
  stopScrollInit();
  autoHeightInit();
  osInit();
  phoneMaskInit();
  datepickerInit();
  cancopyInit();
}


// ==============
const
  media_sm = '576',
  media_md = '768',
  media_lg = '992',
  media_xl = '1280',
  media_xxl = '1600',
  media_xxxl = '1920';
// ==============



// fancybox
Fancybox.bind("[data-fancybox]", {
  infinite: false,
  // slideshow: {
  //   autoStart: true,
  //   delay: 3000,
  // },
  Toolbar: {
    display: ["close"],
  },
  Image: {
    zoom: false,
  },
});
// 





function checkHorScrollbar(target) {
  //Get real width of page scroll-bar
  const h1 = target.scrollHeight;
  target.classList.add('m-overflow-hidden');
  const h2 = target.scrollHeight;
  target.classList.remove('m-overflow-hidden');
  return h2 - h1;
}
// ==============


// FULL POPUP STUFF
function checkScrollbar() {
  //Get real width of page scroll-bar
  const w1 = document.documentElement.clientWidth;
  document.querySelector('html').classList.add('popup_lock');
  const w2 = document.documentElement.clientWidth;
  document.querySelector('html').classList.remove('popup_lock');
  return w2 - w1;
}

function bodyStopScroll() {
  const scrollWidth = checkScrollbar();
  const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_noscrol_pad { padding-right: ${scrollWidth}px; }
        .js_noscrol_margin { margin-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
  if (!document.querySelector('#scrollStuff')) {
    document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  }
  document.body.classList.add('noscroll');


  if (lenis) {
    lenis.stop();
  }

}
function bodyRemoveStopScroll() {

  document.head.querySelectorAll('#scrollStuff').forEach(item => {
    item.remove();
  });

  document.body.classList.remove('noscroll');

  if (lenis) {
    lenis.start();
  }

}

function popupInit() {
  document.querySelectorAll('.js_popup_trigger:not(.isinit)').forEach(trigger => {
    trigger.classList.add('isinit');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      // closePopup();

      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));

      if (popupTarget) {

        if (!popupTarget.classList.contains('js_prevent_stopscrol')) {
          bodyStopScroll();
        }
        popupTarget.classList.add('m-active');

        document.querySelectorAll('.focusHolder').forEach((focusholder) => {
          focusholder.classList.remove('focusholder');
        })
        trigger.classList.add('focusHolder');

        setTimeout(() => {
          popupTarget.setAttribute('tabindex', '-1');
          popupTarget.focus();
          popupTarget.blur();
          popupTarget.removeAttribute('tabindex');
        }, 500);
      }
    });
  });


  document.querySelectorAll('.js_popup_close:not(.isinit)').forEach(trigger => {
    trigger.classList.add('isinit');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });
}

// ==============

let isEsc = false;
document.addEventListener('keyup', function (event) {
  if (event.key === "Escape") {
    isEsc = true;
    closePopup();
    closeHeaderStuff();
  }
});

// ==============

function closePopup() {
  const activePopup = document.querySelector('.js_popup.m-active');
  if (activePopup) {
    activePopup.classList.remove('m-active');
    setTimeout(() => {
      bodyRemoveStopScroll();

      const focusTarget = document.querySelector('.focusHolder');
      if (focusTarget) {
        focusTarget.focus();
        if (!isEsc) {
          focusTarget.blur();
        }
        focusTarget.classList.remove('focusHolder');
      }
      isEsc = false;
    }, 300);
  }
  else {
    isEsc = false;
  }
}
// ==============


// CLOSE HEADER STUFF
function closeHeaderStuff() {
  document.querySelectorAll('.js_checkbox-show:checked').forEach(item => {
    item.checked = false;
    bodyRemoveStopScroll();
  });
}
// ==============



// TABS
function tabsInit() {
  // init first tab 
  document.querySelectorAll('.js_tabs:not(.m-closedbydefault').forEach(item => {
    if (!item.querySelectorAll('.js_tabs_trigger.m-active').length > 0) {
      item.querySelector('.js_tabs_trigger').classList.add('m-active');
      item.querySelector('.js_tabs_tab').classList.add('m-active');
    }
  });
  document.querySelectorAll('.js_tabs_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const tabTarget = document.querySelector(trigger.getAttribute('data-target'))

      trigger.closest('.js_tabs').querySelectorAll('.js_tabs_trigger.m-active,.js_tabs_tab.m-active').forEach(activeItem => {
        activeItem.classList.remove('m-active');
      });


      trigger.classList.add('m-active');
      tabTarget.classList.add('m-active');
    });
  });
}



// INPUT STATUS
function checkFill(item) {
  item.value.length
    ? item.classList.add('m-filled')
    : item.classList.remove('m-filled');
}

function inputsInit() {

  document.querySelectorAll('.js_checkfill:not(.isinit)').forEach(item => {
    item.classList.add('isinit');
    checkFill(item)
    item.onfocus = function () {
      item.classList.add('m-focused');
    }
    item.onblur = function () {
      item.classList.remove('m-focused');
      checkFill(item)
    }
    item.onkeyup = function () {
      checkFill(item)
    }
  });

  // INPUT CLEAR
  document.querySelectorAll('.js_input_clear:not(.isinit)').forEach(item => {
    item.classList.add('isinit');
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const targetInputs = item.parentNode.querySelectorAll('input, textarea');
      targetInputs.forEach(input => {
        input.value = '';
        input.classList.remove('m-filled');
        input.focus();
      });
    });
  });
}

// ========================


// ACTIVE TOGGLE
function activeToggleInit() {
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger:not(.isinit)').forEach(trigger => {
    trigger.classList.add('isinit');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = '';
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }

        if (toggleTarget) {
          trigger.classList.toggle('m-active');
          toggleTarget.classList.toggle('m-active');
        }
        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });
}
// ========================


// STOP SCROLL
function stopScrollInit() {
  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll:not(.isinit)').forEach(trigger => {
    trigger.classList.add('isinit');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!stopscrollHold) {
        stopscrollHold = true;
        if (!document.body.classList.contains('noscroll')) {
          bodyStopScroll();
        } else {
          setTimeout(() => {
            bodyRemoveStopScroll();
          }, 500);
        }
        setTimeout(() => {
          stopscrollHold = false;
        }, 500);
      }
    });
  });
}

// ========================


// textarea resize
function autoHeightInit() {
  document.querySelectorAll('.js_textarea:not(.isinit)').forEach(textarea => {
    textarea.classList.add('isinit');
    autosize(textarea);
  });
}
// =====



// custom scrollbar
var {
  OverlayScrollbars,
  ScrollbarsHidingPlugin,
  SizeObserverPlugin,
  ClickScrollPlugin
} = OverlayScrollbarsGlobal;
function osInit() {
  document.querySelectorAll('.js_scrollbar:not(.isinit)').forEach(item => {
    item.classList.add('isinit');
    const osInstance = OverlayScrollbars(item, {});
  });
}
// ========================


// input masks
function phoneMaskInit() {
  document.querySelectorAll('.js_mask_phone:not(.isinit)').forEach(item => {
    item.classList.add('isinit');
    IMask(
      item,
      {
        mask: '+{7} (000) 000–00–00'
      }
    )
  });
}

// =============

// DATEPICKER
function datepickerInit() {
  document.querySelectorAll('.js_datepicker:not(.dp-isinit)').forEach(item => {
    item.classList.add('dp-isinit');
    const dateInit = item.getAttribute('data-date-init') ? new Date(item.getAttribute('data-date-init')) : new Date();
    const dateMin = item.getAttribute('data-date-min') ? new Date(item.getAttribute('data-date-min')) : new Date();
    const dateMax = item.getAttribute('data-date-max') ? new Date(item.getAttribute('data-date-max')) : '';
    new AirDatepicker(item, {
      // inline: true,
      autoClose: true,
      dateFormat: 'dd.MM.yy',
      selectedDates: [dateInit],
      minDate: dateMin,
      maxDate: dateMax,
    });
  });
}
// ================


// FILE INPUT

document.querySelectorAll('.js_file_input').forEach(fileInput => {
  const targetHolder = fileInput.closest('.js_file');
  const targetInfo = targetHolder.querySelector('.js_file_info');

  fileInput.addEventListener('dragenter', function () {
    targetHolder.classList.add('m-dragging')
  });
  fileInput.addEventListener('dragleave', function () {
    targetHolder.classList.remove('m-dragging')
  });

  fileInput.addEventListener('change', (e) => {
    const files = fileInput.files;
    targetInfo.innerHTML = '';
    if (files.length > 0) {
      targetHolder.classList.add('hasfiles');
      for (let index = 0; index < files.length; index++) {
        targetInfo.insertAdjacentHTML('beforeend', `<div>${files[index].name}</div>`);
      }
    }
    else {
      targetHolder.classList.remove('hasfiles');
    }
    targetHolder.classList.remove('m-dragging');
  });
});


// ===============




// COPY TO CLIPBOARD
let copyToClipboardAsync;
if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
  document.body.classList.add('cancopy');

  copyToClipboardAsync = str => {
    return navigator.clipboard.writeText(str);
    // return Promise.reject('The Clipboard API is not available.');
  }
}
function cancopyInit() {
  document.querySelectorAll('.cancopy .js_copy:not(.isinit)').forEach(trigger => {
    trigger.classList.add('isinit');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      if (!document.body.classList.contains('holdcopy')) {

        let text = '';
        if (trigger.getAttribute('data-copy')) {
          text = trigger.getAttribute('data-copy').replace(/\s+/g, ' ').trim();
          copyToClipboardAsync(text);
        }
        else if (trigger.getAttribute('data-copy-target')) {
          const copyTarget = trigger.getAttribute('data-copy-target');
          if (document.querySelector(copyTarget)) {
            // text = document.querySelector(copyTarget).textContent.replace(/\s+/g, ' ').trim();
            text = document.querySelector(copyTarget).textContent.replace(/\t/g, '').replace(/\n\n\n/g, '\n').trim();
            copyToClipboardAsync(text);
          }
        }
        if (text) {

          document.body.classList.add('holdcopy');

          const textHolder = trigger.querySelector('.js_copy_text'),
            defaultTxt = textHolder.textContent,
            successText = trigger.getAttribute('data-success');

          trigger.classList.add('m-copy-success');

          if (successText) {
            textHolder.innerHTML = successText;
          }

          setTimeout(() => {
            document.body.classList.remove('holdcopy');
            trigger.classList.remove('m-copy-success');
            trigger.blur();
            if (successText) {
              textHolder.innerHTML = defaultTxt;
            }
          }, 1500);

        }
      }
    });
  });
}
// ===================






// ===============



// let's get this party started
document.addEventListener('DOMContentLoaded', function () {



  initAll();



  // account: scroll to current nav item
  function scrollNav() {
    const scrollElement = document.querySelector('.account__nav-item.m-current');
    if (scrollElement) {
      scrollElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }
  scrollNav();
  // ==========




  // HEADER CATALOG SUBLIST STUFF
  let isHcatTouch = false;

  const firstHcatItem = document.querySelector('.hcat__item');
  if (firstHcatItem && window.matchMedia(`(min-width: ${media_md}px)`).matches) {
    firstHcatItem.classList.add('m-active');
  }

  function hcatSetActive(e) {

    const hcat = e.target.closest('.hcat');
    const holder = e.target.closest('.hcat__item');
    if (!holder.classList.contains('m-active')) {
      e.preventDefault();
      hcat.querySelectorAll('.hcat__item.m-active').forEach(item => {
        item.classList.remove('m-active');
      });
      holder.classList.add('m-active');
    }
    isHcatTouch = false;
  }

  document.querySelectorAll('.js_hcat_trigger').forEach(trigger => {
    trigger.addEventListener('touchstart', (e) => {
      isHcatTouch = true;
    });
    if (window.matchMedia(`(min-width: ${media_md}px)`).matches) {
      trigger.addEventListener('mouseenter', (e) => {
        if (!isHcatTouch) {
          hcatSetActive(e);
        }
      });
    }
    trigger.addEventListener('click', hcatSetActive);
  });

  document.querySelectorAll('.js_hcat_back').forEach(trigger => {
    trigger.addEventListener('click', (e) => {

      trigger.closest('.hcat__item').classList.remove('m-active');
    });
  });
  // =========================



  // =========================
  // VIDEO PLAY BUTTON
  document.querySelectorAll('.js_play').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      pauseVideo(); // pause other playing video
      const targetParent = trigger.closest('.video');
      const targetVideo = targetParent.querySelector('video');
      targetParent.classList.add('m-active');
      targetVideo.setAttribute('controls', 'controls')
      targetVideo.play();
    });
  });

  // PAUSE VIDEO ON TAB CHANGE
  document.querySelectorAll('.tabs__radio').forEach(radio => {
    radio.addEventListener('change', (e) => {
      pauseVideo();
    });
  });

  // PAUSE VIDEO 
  function pauseVideo() {
    document.querySelectorAll('video').forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  // =========================





  // HEADER SHOW-CHECKBOX
  document.querySelectorAll('.js_checkbox-show').forEach(trigger => {
    trigger.addEventListener('change', (e) => {

      if (trigger.checked) {
        trigger.classList.add('canttouchthis');
        document.querySelectorAll('.js_checkbox-show:not(.canttouchthis):checked').forEach(checkbox => {
          checkbox.checked = false;
        });

        if (trigger.classList.contains('js_checkbox-stopscroll')) {
          bodyStopScroll();
        }
        trigger.classList.remove('canttouchthis');

      }
      else {
        bodyRemoveStopScroll();
      }
    });
  });



  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (document.head.querySelector('#scrollStuff')) {
          bodyRemoveStopScroll();
        }



      }, 150)
    }
  }, false)




});


// =================================================
// =================================================
// =================================================

